import { Grid, Paper } from '@mui/material';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { officeApiKeyStore } from '../../../api/office-api-key-store';
import { Office } from '../../../models/office';
import { WidgetsContainer } from '../widgets-container.component';
import { DetailsTabs } from './details-tabs';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';

export const OfficeDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useLoadData<ApiResponse<Office>>(officeApiKeyStore.getOffice(id));

  const handleEditOffice = (value: Office) => {
    navigate(`/offices/edit/${id}`);
  };

  const permissionForTab = {
    projectTab: useAuthorize([UserPermissionName.VIEW_PROJECT]),
    unitTab: useAuthorize([UserPermissionName.VIEW_UNIT]),
    contactTab: useAuthorize([UserPermissionName.VIEW_CONTACT]),
    serviceTab: useAuthorize([UserPermissionName.VIEW_SERVICE_OFFICE]),
    serviceBundleTab: useAuthorize([UserPermissionName?.VIEW_SERVICE_BUNDLE]),
    fileTab: useAuthorize([UserPermissionName.VIEW_FILES]),
    contractTab: useAuthorize([UserPermissionName?.VIEW_CONTRACT_OFFICE]),
    planTab: useAuthorize([UserPermissionName?.VIEW_PLAN]),
  };

  return (
    <SiTrackPage
      title={data?.data?.officeName ?? ''}
      onEdit={handleEditOffice}
      isLoading={isLoading}
      actionPermissions={{ edit: UserPermissionName.EDIT_OFFICE }}
    >
      <WidgetsContainer officeID={id} />

      {!permissionForTab?.serviceBundleTab &&
        !permissionForTab?.projectTab &&
        !permissionForTab?.unitTab &&
        !permissionForTab?.contactTab &&
        !permissionForTab?.serviceTab &&
        !permissionForTab?.fileTab &&
        !permissionForTab?.contractTab &&
        !permissionForTab?.planTab ? null : (
        <Grid container justifyContent="space-between" spacing={3} style={{ paddingBottom: '10px' }}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DetailsTabs
              customerID={Number(data?.data?.customerID)}
              officeID={Number(data?.data?.officeID)}
              permissionForTab={permissionForTab}
              contracts={data?.data?.officeContracts}
              pricingListID={data?.data?.pricingListID}
            />
          </Grid>
        </Grid>
      )}

      <Outlet />
    </SiTrackPage>
  );
};
